<template>
  <span>
    <span v-html="string"></span>

    <button v-if="maxChars <= text.length" @click="readMore" class="button">
      {{readMoreLabel}}
    </button>

    <button v-if="maxChars > initialMaxChars" @click="readLess" class="button">
      {{readLessLabel}}
    </button>
  </span>
</template>

<script>
export default{
  name: 'RpmReadMore',
  props: {
    readMoreLabel: {
      type: String,
      default: 'ler mais'
    },
    readLessLabel: {
      type: String,
      default: 'ler menos'
    },
    text: {
      type: String,
      required: true
    },
  },
  data (){
    return{
      initialMaxChars: 0,
      maxChars: 0,
      time: 0,
      string: '',
    }
  },
  methods: {
    getScreenSize(){
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    },
    getTimeMultiplier(multiplier, lessOrMore){
      if(lessOrMore == 'first') return multiplier;
      if(lessOrMore == 'more') return multiplier * ++this.time;
      return multiplier * this.time--;
    },
    getMaxChars(lessOrMore){
      const screenSize = this.getScreenSize();
      if(screenSize < 640) return this.getTimeMultiplier(200, lessOrMore);
      if(screenSize < 768) return this.getTimeMultiplier(400, lessOrMore);
      if(screenSize < 1024) return this.getTimeMultiplier(600, lessOrMore);
      if(screenSize < 1280) return this.getTimeMultiplier(800, lessOrMore);
      return this.getTimeMultiplier(1000, lessOrMore);
    },
    readMore(){
      this.maxChars += this.getMaxChars('more');
      this.string = this.text.substring(0, this.maxChars);
    },
    readLess(){
      this.maxChars -= this.getMaxChars('less');
      this.string = this.text.substring(0, this.maxChars);
    },
    start(text){
      const initialMaxChars = this.getMaxChars('first');
      this.initialMaxChars = initialMaxChars;
      this.maxChars = initialMaxChars;

      this.string = text.substring(0, this.maxChars);
    }
  },
  mounted(){
    this.start(this.text);
  },
  watch: {
    text(newer){
      this.start(newer);
    }
  }
}
</script>

<style scoped>
.button {
  @apply inline underline decoration-dotted decoration-2 decoration-theme font-bold text-sm ml-2;
}
</style>